module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-10-at-2-23-1-5@2x-b06701ad32ad4afa038fbe66902b183a.png";